class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    /** Desktop hover + pointeur fin : ouvre au survol (<990 : drawer, inchangé) */
    this._hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this._hoverCloseTimer = null;
    this._onMenuEnter = this._onMenuEnter.bind(this);
    this._onMenuLeave = this._onMenuLeave.bind(this);
    this.addEventListener('mouseenter', this._onMenuEnter);
    this.addEventListener('mouseleave', this._onMenuLeave);
  }

  _onMenuEnter() {
    if (!this._hoverMedia.matches) return;
    if (this._hoverCloseTimer) {
      clearTimeout(this._hoverCloseTimer);
      this._hoverCloseTimer = null;
    }

    document.querySelectorAll('header-menu').forEach((other) => {
      if (other !== this && typeof other.close === 'function') other.close();
    });

    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    if (this.header) this.header.preventHide = true;
    this._syncHeaderBottomVar();
  }

  _onMenuLeave() {
    if (!this._hoverMedia.matches) return;
    this._hoverCloseTimer = window.setTimeout(() => {
      this._hoverCloseTimer = null;
      if (!this.matches(':focus-within')) this.close();
    }, 160);
  }

  _syncHeaderBottomVar() {
    if (!this.header) return;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  close() {
    if (this._hoverCloseTimer) {
      clearTimeout(this._hoverCloseTimer);
      this._hoverCloseTimer = null;
    }
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
